import { render } from "./property-nearbycity.vue?vue&type=template&id=4b60ceb1"
import script from "./property-nearbycity.js?vue&type=script&lang=js"
export * from "./property-nearbycity.js?vue&type=script&lang=js"

import "./property-nearbycity.vue?vue&type=style&index=0&id=4b60ceb1&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__